import { render, staticRenderFns } from "./AddNewLawClientForm.vue?vue&type=template&id=5f7e698d&"
import script from "./AddNewLawClientForm.vue?vue&type=script&lang=js&"
export * from "./AddNewLawClientForm.vue?vue&type=script&lang=js&"
import style0 from "./AddNewLawClientForm.vue?vue&type=style&index=0&id=5f7e698d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports